/*
  assets/nibec-comparar.js · Bigbuda T-0449 · Ola 3 (14-oct-2026)
  Medición de «Compara con otros modelos» en la ficha (snippets/nibec-comparar-modelos.liquid).
  Un clic en una tarjeta publica nibec_comparar_click (Shopify.analytics y dataLayer) con la ficha de origen, el modelo de
  destino, su posición, su carga en kg y el dispositivo. No cambia nada visible ni la navegación.
  Heatmap lee data-hm-id="pdp-comparar-N" en cada tarjeta.
*/
(function () {
  if (window.__nibecComparar) return;
  window.__nibecComparar = true;

  document.addEventListener(
    'click',
    function (e) {
      var item = e.target && e.target.closest ? e.target.closest('[data-nibec-comp]') : null;
      if (!item) return;
      var datos = {
        origen: location.pathname.split('/').filter(Boolean).pop() || '',
        destino: item.getAttribute('data-nibec-comp') || '',
        posicion: parseInt(item.getAttribute('data-nibec-comp-pos'), 10) || 0,
        carga_kg: parseInt(item.getAttribute('data-nibec-comp-kg'), 10) || 0,
        dispositivo: window.matchMedia && window.matchMedia('(max-width: 749px)').matches ? 'celular' : 'computador'
      };
      try {
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('nibec_comparar_click', datos);
      } catch (err) {}
      try {
        (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'nibec_comparar_click' }, datos));
      } catch (err) {}
    },
    true
  );
})();
